"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _mergeColumnTree = function mergeColumnTree(list) {
  if (!Array.isArray(list)) {
    throw new Error('Param should be an array');
  }
  if (list.length < 2) {
    return list[0];
  }
  if (Array.isArray(list[0])) {
    var union = list.reduce(function (result, item) {
      result.push.apply(result, _toConsumableArray(item));
      return result;
    }, []);
    if (!union[0] || !union[0].id) {
      return union;
    }
    if (union[0].id) {
      var uniqArray = (0, _uniqBy2["default"])(union, 'id');
      if (union[0].children) {
        var keys = union.reduce(function (obj, item) {
          obj[item.id] = obj[item.id] || [];
          obj[item.id].push(item.children);
          return obj;
        }, {});
        uniqArray.forEach(function (item) {
          item.children = _mergeColumnTree(keys[item.id]);
        });
      }
      return uniqArray;
    }
    return union;
  }
  if (_typeof(list[0]) === 'object') {
    var combinedObject = list.reduce(function (obj, item) {
      for (var _i = 0, _Object$entries = Object.entries(item); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        obj[key] = obj[key] || [];
        obj[key].push(value);
      }
      return obj;
    }, {});
    return (0, _mapValues2["default"])(combinedObject, function (value) {
      return _mergeColumnTree(value);
    });
  }
  return list[0];
};
var _default = exports["default"] = _mergeColumnTree;